import type { ButtonHTMLAttributes } from "react";
import { Link, type To } from "react-router";
import s from "./ui.module.css";

type Art = "primaer" | "normal" | "gefahr" | "leise";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  art?: Art;
  klein?: boolean;
  /** Primärknopf ohne orangen Punkt (zum Beispiel in Dialogen) */
  ohnePunkt?: boolean;
}

export function Knopf({ art = "normal", klein, ohnePunkt, className, type = "button", ...rest }: Props) {
  const klassen = [s.knopf, art === "primaer" && s.primaer, art === "primaer" && ohnePunkt && s.primaerOhnePunkt, art === "gefahr" && s.gefahr, art === "leise" && s.leise, klein && s.klein, className]
    .filter(Boolean)
    .join(" ");
  return <button type={type} className={klassen} {...rest} />;
}

/** Link, der wie ein Knopf aussieht (für Navigation, kein verschachtelter Knopf im Link). */
export function KnopfLink({ to, state, art = "normal", klein, children }: { to: To; state?: unknown; art?: Art; klein?: boolean; children: React.ReactNode }) {
  const klassen = [s.knopf, art === "primaer" && s.primaer, art === "gefahr" && s.gefahr, art === "leise" && s.leise, klein && s.klein].filter(Boolean).join(" ");
  return (
    <Link to={to} state={state} className={klassen}>
      {children}
    </Link>
  );
}
